import React, { FC, ReactElement } from 'react'
import { Button, Row, Col, Form } from 'antd'
import { FormListFieldData, FormListOperation } from 'antd/es/form/FormList'
import { SignerFormItem } from './SignerFormItem'
import { Signer, SignersFormProps } from './types'
import './styles.modules.scss'
import Utils from '../utils'

export const SignersForm: FC<SignersFormProps> = ({ maxSigners = 4, ronSigning = false }): ReactElement => {
  return (
    <div className="signers-form">
      <Form.List
        name="signers"
        rules={[
          {
            validator: async (_: any, signers: Signer[]) => {
              if (!signers || signers.length === 0) {
                return Promise.reject(new Error('At least one signer is required'))
              }
              return Promise.resolve()
            }
          }
        ]}
      >
        {(
          fields: FormListFieldData[],
          { add, remove }: FormListOperation,
          { errors }: { errors: React.ReactNode[] }
        ) => (
          <>
            {fields.map((field: FormListFieldData, index: number) => (
              <SignerFormItem
                key={field.key}
                field={field}
                index={index}
                remove={remove}
                showRemove={index > 0}
                emailRequired={ronSigning}
                cellPhoneRequired={ronSigning}
              />
            ))}

            {fields.length < maxSigners && (
              <Row>
                <Col span={24}>
                  <Button type="link" onClick={() => add(Utils.defaultSigner)} className="add-signer-button">
                    + Add signer
                  </Button>
                </Col>
              </Row>
            )}
            <Form.ErrorList errors={errors} />
          </>
        )}
      </Form.List>
    </div>
  )
}

export default SignersForm
